<template>
  <svg viewBox="0 0 160 220" aria-hidden="true">
    <g v-for="(leaf, i) in leaves" :key="i">
      <path :d="'M80 150 Q' + leaf.cx + ' ' + leaf.cy + ' ' + leaf.x + ' ' + leaf.y" fill="none" stroke="#4F7A5C"
        stroke-width="3" stroke-linecap="round" />
      <g :transform="'translate(' + leaf.x + ' ' + leaf.y + ') rotate(' + leaf.angle + ') scale(' + leaf.scale + ')'">
        <path d="M0 0C14-15 44-15 60 0 44 15 14 15 0 0Z" :fill="leaf.fill" />
        <path d="M4 0H52" stroke="#2F4A3A" stroke-opacity=".25" stroke-width="2" stroke-linecap="round" />
      </g>
    </g>
    <path d="M42 152h76l-9 56a7 7 0 0 1-7 6H58a7 7 0 0 1-7-6Z" fill="#C26A35" />
    <rect x="34" y="142" width="92" height="16" rx="7" fill="#E0915F" />
    <path d="M52 178h56" stroke="#F2B98F" stroke-opacity=".5" stroke-width="3" stroke-linecap="round" />
  </svg>
</template>

<script>
export default {
  name: "IlloPlant",
  data() {
    return {
      leaves: [
        { x: 46, y: 112, cx: 66, cy: 130, angle: -150, scale: 0.9, fill: "#6B8F71" },
        { x: 112, y: 108, cx: 96, cy: 128, angle: -30, scale: 0.95, fill: "#A9C4A5" },
        { x: 70, y: 72, cx: 76, cy: 110, angle: -112, scale: 1.05, fill: "#A9C4A5" },
        { x: 96, y: 66, cx: 88, cy: 108, angle: -66, scale: 1.1, fill: "#6B8F71" },
        { x: 40, y: 138, cx: 60, cy: 146, angle: -175, scale: 0.7, fill: "#A9C4A5" },
        { x: 120, y: 136, cx: 100, cy: 146, angle: -8, scale: 0.7, fill: "#6B8F71" },
      ],
    };
  },
};
</script>
